import { Component, type PropsWithChildren } from 'react';

type ErrorBoundaryState = {
    hasError: boolean;
    error?: Error;
};

export class ErrorBoundary extends Component<PropsWithChildren, ErrorBoundaryState> {
    constructor(props: PropsWithChildren) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    render() {
        const { children } = this.props;
        const { hasError, error } = this.state;

        if (hasError) {
            return (
                <>
                    <p className='text-size-18 text-thin'>Something went wrong!</p>
                    <pre className='text-size-12'>{error?.message}</pre>
                    <pre className='text-size-12'>{error?.stack}</pre>
                </>
            );
        }

        return children;
    }
}
